module.exports = __webpack_public_path__ + "img/nightelf_siege_factory_small.29b8f7dc.png";